<template>
  <div>
    <div style="margin:15px auto">
      <el-date-picker
        v-model="searchDate"
        type="daterange"
        size="mini"
        range-separator="至"
        start-placeholder="来访开始日期"
        end-placeholder="来访结束日期"
        style="width:300px;"
      ></el-date-picker>
      <el-input placeholder="来访企业" v-model="searchCompany" size="mini" style="width:250px;"></el-input>
      <el-input placeholder="受访部门" v-model="searchDept" size="mini" style="width:200px;"></el-input>
      <el-select size="mini" v-model="selState" placeholder="请选择">
        <el-option label="未准入" value="0"></el-option>
        <el-option label="已准入" value="1"></el-option>
      </el-select>
      <el-button type="primary" size="mini" @click="searchData()">查询</el-button>
    </div>
    <template>
      <el-table :data="listData.list" border style="width: 100%">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span
              style="margin-left: 10px"
            >{{ scope.$index+1+(listData.pageIndex-1)*listData.pageSize }}</span>
          </template>
        </el-table-column>
        <el-table-column label="来访单位" align="left">
          <template slot-scope="scope">
            <label v-if="scope.row.reservationType===0" class="label greenlabel">预</label>
            <label v-else class="label">临</label>
            {{scope.row.visitorCompanyName}}
          </template>
        </el-table-column>
        <el-table-column label="来访人" width="70">
          <template slot-scope="scope">
            <slot>{{scope.row.visitorUserName}}</slot>
          </template>
        </el-table-column>
        <el-table-column prop="actualPeopleCount" label="人数" width="50"></el-table-column>
        <el-table-column prop="reservationDate" label="预约时间" width="110"></el-table-column>
        <el-table-column prop="visitorProvinceCode" label="来自区域" width="80"></el-table-column>
        <el-table-column prop="targetUserName" label="受访人" width="70"></el-table-column>
        <el-table-column prop="targetDepartmentName" label="部门" width="100"></el-table-column>
        <el-table-column label="联系方式" width="130">
          <template slot-scope="scope">
            <div>{{scope.row.mobile!=undefined?scope.row.mobile:''}}</div>
            <div>{{scope.row.phone!=undefined?scope.row.phone:''}}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.state===1" style="color:blue;">待批准</span>
            <span v-if="scope.row.state===2" style="color:blue;">待访问</span>
            <span v-if="scope.row.state===3" style="color:blue;">待离开</span>
            <span v-if="scope.row.state===4" style="color:blue;">已变更</span>
            <span v-if="scope.row.state===5" style="color:blue;">已取消</span>
            <span v-if="scope.row.state===6" style="color:blue;">已结束</span>
            <span v-if="scope.row.state===7" style="color:blue;">已拒绝</span>
            <span v-if="scope.row.state===10" style="color:blue;">已访问</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="操作" width="80">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click.stop="oper(scope.row)"
              size="mini"
              plain
            >{{scope.row.state===6?'查看':'登记'}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="other-list-page">
        <el-pagination
          background
          layout="prev, pager, next"
          small="true"
          :page-size="listData.pageSize"
          :page-count="listData.totalPageCount"
          :total="listData.totalCount"
          :current-page.sync="listData.pageIndex"
          @current-change="searchData()"
        ></el-pagination>
      </div>
    </template>
    <resCheckInfo ref="checkApp"></resCheckInfo>
  </div>
</template>
<script>
import resCheckInfo from "@/components/fksys/resCheckInfo";
import publish_ from "@/components/publish"; //引用模块进来
import {
  getReservationListByCondition,
  getReservationRecords, //获取操作记录
  getReservationUserDto, //获取来访人
  getReservationCompanies, //获取随行人员
  isExistVisitorInfo,
  addVisitorType, //添加某个人到黑白名单
  getCompaniesInfo, //获取人员信息
  imgUrl
} from "@/api/api";

export default {
  components: {
    resCheckInfo: resCheckInfo
  },
  data() {
    return {
      user: {},
      listData: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 10,
        totalPageCount: 1,
        list: []
      }, //列表集合数据
      searchDate: "",
      searchCompany: "",
      searchDept: "",
      selState:'0'

    };
  }, //超过8个字符隐藏后面的
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    }
  },
  created() {
    this.user = JSON.parse(window.localStorage.user);
    this.loadPara();
    this.searchData();
  },
  methods: {
    loadPara() {
      this.tableRowData = {
        radio: "0",
        row: {}, //行对象
        user: {}, //来访人员
        userDto: [], //随行人员集合
        bfshDate: "", //拜访审核时间
        wcqrDate: "", //完成确认时间
        inDate: "", //进入时间
        inWriterOper: "", //值班登记人
        outDate: "", //离开时间
        outWriterOper: "" //值班登记人
      }; //预约弹出框对象
    },
    //state状态(0:全部;1:已准入;2:未准入),rType预约类型（0：预先预约，1临时预约,2超期未登记）
    searchData() {
      var para = {
        params: {
          pageIndex: this.listData.pageIndex,
          pageSize: this.listData.pageSize,
          targetCompanyId: this.user.companyId,
          reservationBeginTime:
            this.searchDate === null ? "" : this.searchDate[0],
          reservationEndTime:
            this.searchDate === null ? "" : this.searchDate[1],
          visitorCompanyName: this.searchCompany,
          targetDepartmentName: this.searchDept
        }
      };
      var _this = this;
      getReservationListByCondition(para).then(res => {
        if (res.data.success) {
          _this.listData = res.data.data;
        } else {
          _this.$message.error(res.data.message);
        }
      });
    },
    //详细
    oper(row) {
      this.$refs.checkApp.oper(row.id);
    },
    //更新人员信息
    getUsers() {
      var _this = this;
      var para = {
        params: { reservationId: this.tableRowData.row.id }
      };
      //获取来访人
      var model = {};
      getReservationUserDto(para).then(res => {
        if (res.data.success) {
          try {
            _this.tableRowData.user = res.data.data;
            model = {
              params: {
                userName: res.data.data.name,
                idCardNumber: res.data.data.idCardNumber
              }
            };
            _this.formVisible = false;
            _this.formVisible = true;

            isExistVisitorInfo(model).then(res => {
              if (res.data.data != undefined && res.data.data.id != undefined) {
                _this.tableRowData.user.blackKey = res.data.data.id;
                _this.tableRowData.user.blackVal = res.data.data.category;
              } else {
                _this.tableRowData.user.blackVal = 9;
              }

              _this.formVisible = false;
              _this.formVisible = true;
            });
          } catch (e) {}
        }
      });

      //获取随行人员
      getReservationCompanies(para).then(res => {
        if (res.data.success) {
          try {
            _this.tableRowData.userDto = res.data.data;
            _this.tableRowData.userDto.forEach(element => {
              var _element = element;
              model = {
                params: {
                  userName: element.name,
                  idCardNumber: element.idCardNumber
                }
              };
              _this.formVisible = false;
              _this.formVisible = true;
              isExistVisitorInfo(model).then(res => {
                if (
                  res.data.data != undefined &&
                  res.data.data.id != undefined
                ) {
                  _element.blackKey = res.data.data.id;
                  _element.blackVal = res.data.data.category;
                } else {
                  _element.blackVal = 9;
                }
                _this.formVisible = false;
                _this.formVisible = true;
              });
            });
          } catch (e) {}
        }
      });
    },
    //显示健康卡信息
    showCard1() {
      var _this = this;
      var para = { params: { userId: this.tableRowData.user.id } };
      getCompaniesInfo(para).then(res => {
        if (res.data.data.feedBackContent === undefined) {
          _this.$message.error("该人员健康卡信息为空");
        } else {
          var obj = JSON.parse(res.data.data.feedBackContent);

          _this.cardObj = [];
          for (var i = 0; i < 6; i++) {
            var mod = obj.find(a => a.category === i);
            if (mod != null) {
              _this.cardObj.push(mod);
            } else {
              break;
            }
          }
          _this.cardVisible = true;
        }
      });
    },
    showCard2(index) {
      var _this = this;
      var para = { params: { userId: this.tableRowData.userDto[index].id } };
      getCompaniesInfo(para).then(res => {
        if (res.data.data.feedBackContent === undefined) {
          _this.$message.error("该人员健康卡信息为空");
        } else {
          var obj = JSON.parse(res.data.data.feedBackContent);
          _this.cardObj = [];
          for (var i = 0; i < 6; i++) {
            var mod = obj.find(a => a.category === i);
            if (mod != null) {
              _this.cardObj.push(mod);
            } else {
              break;
            }
          }
          _this.cardVisible = true;
        }
      });
    },
    //转白名单
    toWhite(model) {
      var para = {
        id: model.blackKey,
        userId: model.id,
        userName: model.name,
        idCardNumber: model.idCardNumber,
        companyId: model.companyId,
        category: 0
      };
      var _model = model;
      addVisitorType(para).then(res => {
        if (res.data.success) {
          this.getUsers();
        }
      });
    },
    //转黑名单
    toBlack(model) {
      var para = {
        id: model.blackKey,
        userId: model.id,
        userName: model.name,
        idCardNumber: model.idCardNumber,
        companyId: model.companyId,
        category: 1
      };
      var _model = model;
      addVisitorType(para).then(res => {
        if (res.data.success) {
          this.getUsers();
        }
      });
    }
  }
};
</script>

<style scoped>
img {
  border: 0;
  margin: 0;
  padding: 0;
  max-width: 600px;
  width: expression(this.width>560? "560px": this.width);
  max-height: 600px;
  height: expression(this.height>560? "560px": this.height);
}
</style>



// WEBPACK FOOTER //
// src/views/fksys/lfjl.vue